<template>
  <section class="bsp" aria-labelledby="bsp-title">
    <h3 id="bsp-title" class="bsp__title">¿Cómo quieres empezar?</h3>
    <p class="bsp__sub">Elige si Parkos cobra desde hoy o si también incluye los meses anteriores de tus contratos.</p>

    <label class="bsp__opt" :class="{ 'bsp__opt--on': mode === 'ZERO' }">
      <input type="radio" name="bsp-mode" value="ZERO" :checked="mode === 'ZERO'" @change="setMode('ZERO')" />
      <span class="bsp__opt-body">
        <span class="bsp__opt-title">Empezar de cero</span>
        <span class="bsp__opt-desc">Parkos cobra desde hoy. No se genera nada de meses pasados. Si algún inquilino ya te debe, lo capturas como un cargo manual.</span>
      </span>
    </label>

    <label class="bsp__opt" :class="{ 'bsp__opt--on': mode === 'HISTORY' }">
      <input type="radio" name="bsp-mode" value="HISTORY" :checked="mode === 'HISTORY'" @change="setMode('HISTORY')" />
      <span class="bsp__opt-body">
        <span class="bsp__opt-title">Incluir meses anteriores</span>
        <span class="bsp__opt-desc">Parkos genera las rentas desde el mes que elijas, para que Cobranza y Finanzas tengan historial.</span>
      </span>
    </label>

    <div v-if="mode === 'HISTORY'" class="bsp__detail">
      <label class="bsp__field">
        <span class="bsp__label">Desde el mes</span>
        <input type="month" class="bsp__month" :value="from" :max="currentMonth" @input="$emit('update:from', $event.target.value)" />
      </label>

      <div class="bsp__radios" role="radiogroup" aria-label="Estado de los meses anteriores">
        <label class="bsp__radio">
          <input type="radio" name="bsp-paid" :checked="assumedPaid" @change="$emit('update:assumedPaid', true)" />
          <span><strong>Marcar esos meses como pagados</strong> (recomendado). Se guarda el historial sin generar deuda ni alertas.</span>
        </label>
        <label class="bsp__radio">
          <input type="radio" name="bsp-paid" :checked="!assumedPaid" @change="$emit('update:assumedPaid', false)" />
          <span><strong>Dejarlos pendientes de cobro.</strong> Aparecerán como cartera vencida y generarán alertas y recordatorios.</span>
        </label>
      </div>

      <p class="bsp__note">Cada contrato empieza en su fecha real de inicio o en el mes que elegiste, lo que ocurra después.</p>
    </div>
  </section>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  mode: { type: String, default: 'ZERO' },
  from: { type: String, default: '' },
  assumedPaid: { type: Boolean, default: true },
  defaultFrom: { type: String, default: '' },
})
const emit = defineEmits(['update:mode', 'update:from', 'update:assumedPaid'])

const currentMonth = computed(() => {
  const d = new Date()
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`
})

function setMode(next) {
  emit('update:mode', next)
  if (next === 'HISTORY' && !props.from) emit('update:from', props.defaultFrom || currentMonth.value)
}
</script>

<style scoped>
.bsp { display: flex; flex-direction: column; gap: 10px; margin-bottom: 18px; }
.bsp__title { margin: 0; font: 600 14px Inter, sans-serif; color: #1e3a5f; }
.bsp__sub { margin: 0 0 2px; font: 400 12px/1.5 Inter, sans-serif; color: #64748b; }
.bsp__opt { display: flex; gap: 10px; align-items: flex-start; padding: 12px 14px; border: 1px solid #e2e8f0; border-radius: 10px; background: #fff; cursor: pointer; }
.bsp__opt--on { border-color: #3b82f6; background: #eff6ff; }
.bsp__opt input { margin-top: 3px; accent-color: #3b82f6; }
.bsp__opt-body { display: flex; flex-direction: column; gap: 2px; min-width: 0; }
.bsp__opt-title { font: 600 13px Inter, sans-serif; color: #1e3a5f; }
.bsp__opt-desc { font: 400 12px/1.5 Inter, sans-serif; color: #64748b; }
.bsp__detail { display: flex; flex-direction: column; gap: 12px; padding: 12px 14px; border: 1px dashed #bfdbfe; border-radius: 10px; background: #f8fafc; }
.bsp__field { display: flex; align-items: center; gap: 10px; flex-wrap: wrap; }
.bsp__label { font: 500 12px Inter, sans-serif; color: #475569; }
.bsp__month { height: 34px; padding: 0 10px; border: 1px solid #e2e8f0; border-radius: 6px; font: 400 13px Inter, sans-serif; color: #1e3a5f; background: #fff; }
.bsp__radios { display: flex; flex-direction: column; gap: 8px; }
.bsp__radio { display: flex; gap: 8px; align-items: flex-start; font: 400 12px/1.5 Inter, sans-serif; color: #475569; cursor: pointer; }
.bsp__radio input { margin-top: 3px; accent-color: #3b82f6; }
.bsp__note { margin: 0; font: 400 11px/1.5 Inter, sans-serif; color: #3b82f6; }
</style>